__turbopack_context__.v({
  "collapsed": "neYJAq_collapsed",
  "menuWrapper": "neYJAq_menuWrapper",
  "mobileHeaderContainer": "neYJAq_mobileHeaderContainer",
  "mobileHeaderWrapper": "neYJAq_mobileHeaderWrapper",
  "mobileMenuWrapper": "neYJAq_mobileMenuWrapper",
  "subNavigationItem": "neYJAq_subNavigationItem",
  "subNavigationLink": "neYJAq_subNavigationLink",
});
